<app-modern-category-slider-home  (selectedCategory)="changeCategory($event)" (selectedSortValue)="sortProducts($event)" [selected]="selectedCategoryId"></app-modern-category-slider-home>
